import React from 'react';
import PropTypes from 'prop-types';

import Tab from '../../../components/Tab';

const Minors = ({ minors, labels, onKeywordChange, searchInputValue }) => {
  return (
    <Tab.Pane className="minors">
      <div className="filters">
        <div className="filter search">
          <label tabIndex={0}>{labels.searchByKeyword}</label>
          <input
            data-type="minors"
            placeholder={labels.searchPlaceholder}
            onChange={onKeywordChange}
            defaultValue={searchInputValue}
          />
        </div>
      </div>
      <div className="list-container">
        <ul>
          {minors.map(minor => (
            <li key={minor} tabIndex={0}>
              {minor}
            </li>
          ))}
        </ul>
      </div>
    </Tab.Pane>
  );
};

Minors.propTypes = {
  searchInputValue: PropTypes.string,
  minors: PropTypes.arrayOf(PropTypes.string),
  labels: PropTypes.shape({
    searchByKeyword: PropTypes.string,
    searchPlaceholder: PropTypes.string,
  }),
  onKeywordChange: PropTypes.func,
};

Minors.defaultProps = {
  minors: [],
};

export default Minors;
